<template>
<v-row>
  <v-col>
    <app-alert-in-page class="mb-2" variant="info" :dismissible="false" data-locator="ongoing-seance-alert">
      <v-row>
        <v-col class="heading-xs-bold text-text-primary">
          {{ computedTitle }}
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="d-md-flex align-center justify-space-between text-text-secondary">
            <div class="d-flex align-center">
              <div v-if="startDate"
                class="d-flex align-center column-gap-2 mr-6"
                data-locator="seance-start-date"
              >
                <app-material-icon name="calendar_today" color="icon-info" />
                <span>{{ $t('project.signing-checklist.list.SigningChecklistSigningInfo.startDate') }}</span>
                <span class="body-md-bold">{{ startDate }}</span>
              </div>
              <div v-if="endDate"
                class="d-flex align-center column-gap-2"
                data-locator="seance-end-date"
              >
                <app-material-icon name="calendar_today" color="icon-info" />
                <span>{{ $t('project.signing-checklist.list.SigningChecklistSigningInfo.endDate') }}</span>
                <span class="body-md-bold">{{ endDate }}</span>
              </div>
            </div>
            <div v-if="isCurrentUserPm" class="d-flex mt-4 mt-md-0">
              <AppButton color="info"
                         link
                         class="mr-4"
                         data-locator="modify-seance-button"
                         @click="$emit('editSigningDates')"
              >
                <app-material-icon name="edit" class="mr-2" color="icon-info" />
                {{ $t('project.signing-checklist.list.SigningChecklistSigningInfo.modify') }}
              </AppButton>
              <AppTooltip :disabled="!isSendingDocument">
                <template #activator="{ props }">
                  <div v-bind="props">
                    <AppButton v-if="closingInProgress"
                            color="info"
                            variant="outlined"
                            :disabled="isSendingDocument"
                            data-locator="stop-seance-button"
                            @click="cancelClosingDialogIsOpen = true"
                    >
                      <app-material-icon name="close" class="mr-2" color="icon-info" />
                      {{ $t('project.signing-checklist.list.SigningChecklistSigningInfo.cancelSigning') }}
                    </AppButton>
                  </div>
                </template>
                {{ $t('project.signing-checklist.list.SigningChecklistSigningInfo.tooltipDisabledCancelSigning') }}
              </AppTooltip>
              <AppButton v-if="closingScheduled"
                         class="btn-allow-wrap"
                         color="info"
                         variant="outlined"
                         @click="cancelScheduledSigningDialogIsOpen = true"
              >
                <app-material-icon name="close" class="mr-2" color="icon-info" />
                {{ $t('project.signing-checklist.list.SigningChecklistSigningInfo.cancelScheduledSigning') }}
              </AppButton>
            </div>
          </div>
        </v-col>
      </v-row>
    </app-alert-in-page>

    <CancelScheduledSigningDialog v-if="cancelScheduledSigningDialogIsOpen && isCurrentUserPm"
                                  :mnemo="mnemo"
                                  @close="cancelScheduledSigningDialogIsOpen = false"
    />
    <SigningChecklistCancelClosingDialog v-if="cancelClosingDialogIsOpen && isCurrentUserPm"
                                         :mnemo="mnemo"
                                         @close="cancelClosingDialogIsOpen = false"
    />
  </v-col>
</v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import AppButton from '@/common/buttons/AppButton.vue'
import { ISOToShortDate } from '@/common/utils/dates'
import CancelScheduledSigningDialog from '@/project/signing-checklist/list/CancelScheduledSigningDialog.vue'
import SigningChecklistCancelClosingDialog from '@/project/signing-checklist/list/SigningChecklistCancelClosingDialog.vue'

export default {
  name: 'SigningChecklistSigningInfo',
  components: { AppButton, AppTooltip, CancelScheduledSigningDialog, SigningChecklistCancelClosingDialog },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    isSendingDocument: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      cancelScheduledSigningDialogIsOpen: false,
      cancelClosingDialogIsOpen: false,
    }
  },
  computed: {
    ...mapState('room', ['currentRoom']),
    ...mapGetters('room', ['isCurrentUserPm']),
    closingInProgress () {
      return this.currentRoom.inClosing
    },
    closingScheduled () {
      return this.currentRoom.closingScheduledAt && !this.closingInProgress
    },
    computedTitle () {
      return this.closingInProgress ? this.$t('project.signing-checklist.list.SigningChecklistSigningInfo.inClosingTitle') : this.$t('project.signing-checklist.list.SigningChecklistSigningInfo.scheduledTitle')
    },
    startDate () {
      if (this.currentRoom.closingScheduledAt) {
        return ISOToShortDate(this.currentRoom.closingScheduledAt)
      } else if (this.currentRoom.closingStartedAt) {
        return ISOToShortDate(this.currentRoom.closingStartedAt)
      }
      return null
    },
    endDate () {
      if (this.currentRoom.closingScheduledEndAt) {
        return ISOToShortDate(this.currentRoom.closingScheduledEndAt)
      }
      return null
    },
  },
}
</script>
